document.querySelectorAll('[data-bundle-builder]').forEach((root) => {
    const mode = root.dataset.selectionMode === 'minimum' ? 'minimum' : 'fixed';
    const size = parseInt(root.dataset.bundleSize || '6', 10);
    const minItems = Math.max(1, parseInt(root.dataset.minItems || '4', 10));
    const discount = root.dataset.discountCode || '';
    const propertyName = root.dataset.propertyName || 'Bundle';
    const propertyValue = root.dataset.propertyValue || '';
    const progressTpl = root.dataset.progressTemplate || '[done] of [total] picked';
    const removeLabelTpl = root.dataset.removeLabel || 'Remove item [index]';
    const slotsContainer = root.querySelector('[data-bundle-slots]');
    const products = Array.from(root.querySelectorAll('[data-bundle-product]'));
    const atc = root.querySelector('[data-bundle-atc]');
    const atcLabel = root.querySelector('[data-bundle-atc-label]');
    const progress = root.querySelector('[data-bundle-progress]');

    if (!slotsContainer || !atc) return;

    const baseLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';
    // Ordered list of picks: { variantId, title, image }. No fixed length —
    // fixed mode caps it at `size`, minimum mode lets it grow past `minItems`.
    const picks = [];

    const enough = () => (mode === 'fixed' ? picks.length === size : picks.length >= minItems);
    const target = mode === 'fixed' ? size : minItems;

    const confettiOn = root.dataset.confetti === 'true';
    let wasEnough = false;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function burstConfetti() {
      if (reduceMotion) return;
      const colors = ['#B8726A', '#9B7B8A', '#F3EAEC', '#FAF7F4', '#1A1A1A'];
      const c = document.createElement('canvas');
      c.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:9999';
      c.width = window.innerWidth; c.height = window.innerHeight;
      document.body.appendChild(c);
      const ctx = c.getContext('2d');
      const r = root.getBoundingClientRect();
      const ox = r.left + r.width / 2, oy = r.top + Math.min(r.height / 2, 220);
      const parts = [];
      for (let i = 0; i < 90; i++) {
        const a = Math.random() * Math.PI * 2, sp = 4 + Math.random() * 8;
        parts.push({ x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 7, g: 0.18 + Math.random() * 0.12, s: 5 + Math.random() * 7, rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.5, col: colors[i % colors.length], life: 1 });
      }
      let t0 = performance.now();
      (function frame(t) {
        const dt = Math.min(2, (t - t0) / 16.67); t0 = t;
        ctx.clearRect(0, 0, c.width, c.height);
        let alive = false;
        parts.forEach((p) => {
          p.vy += p.g * dt; p.x += p.vx * dt; p.y += p.vy * dt; p.rot += p.vr * dt; p.life -= 0.012 * dt;
          if (p.life > 0 && p.y < c.height + 24) {
            alive = true;
            ctx.save(); ctx.globalAlpha = Math.max(0, p.life); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
            ctx.fillStyle = p.col; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.62); ctx.restore();
          }
        });
        if (alive) requestAnimationFrame(frame); else c.remove();
      })(t0);
    }

    const removeAt = (i) => {
      picks.splice(i, 1);
      renderAll();
    };

    // Fixed mode: static slots rendered by Liquid, updated in place.
    const fixedSlots = mode === 'fixed' ? Array.from(slotsContainer.querySelectorAll('[data-bundle-slot]')) : [];

    const renderSlotsFixed = () => {
      fixedSlots.forEach((slot, i) => {
        const pick = picks[i];
        const remove = slot.querySelector('[data-bundle-slot-remove]');
        const img = slot.querySelector('.bundle-builder__slot-image');
        if (pick) {
          slot.dataset.filled = 'true';
          if (img) img.style.backgroundImage = `url("${pick.image}")`;
          if (remove) remove.hidden = false;
        } else {
          slot.dataset.filled = 'false';
          if (img) img.style.backgroundImage = '';
          if (remove) remove.hidden = true;
        }
      });
    };

    // Minimum mode: slots are built from the picks, plus empty placeholders up
    // to the minimum so the "you need at least N" hint is always visible.
    const renderSlotsMinimum = () => {
      slotsContainer.textContent = '';
      const slotCount = Math.max(minItems, picks.length + 1);
      for (let i = 0; i < slotCount; i += 1) {
        const pick = picks[i];
        const li = document.createElement('li');
        li.className = 'bundle-builder__slot';
        li.dataset.bundleSlot = '';
        li.dataset.slotIndex = String(i);
        if (pick) {
          li.dataset.filled = 'true';
          const img = document.createElement('span');
          img.className = 'bundle-builder__slot-image';
          img.setAttribute('aria-hidden', 'true');
          img.style.backgroundImage = `url("${pick.image}")`;
          const rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'bundle-builder__slot-remove';
          rm.textContent = '×';
          rm.setAttribute('aria-label', removeLabelTpl.replace('[index]', String(i + 1)));
          rm.addEventListener('click', () => removeAt(i));
          li.append(img, rm);
        } else {
          li.dataset.filled = 'false';
          const num = document.createElement('span');
          num.className = 'bundle-builder__slot-number';
          num.textContent = String(i + 1);
          li.appendChild(num);
        }
        slotsContainer.appendChild(li);
      }
    };

    const renderCounts = () => {
      const counts = new Map();
      picks.forEach((p) => counts.set(p.variantId, (counts.get(p.variantId) || 0) + 1));
      products.forEach((p) => {
        p.dataset.pickedCount = String(counts.get(p.dataset.variantId) || 0);
      });
    };

    const renderProgress = () => {
      const done = picks.length;
      if (progress) progress.textContent = progressTpl.replace('[done]', String(done)).replace('[total]', String(target));
      const nowEnough = enough();
      atc.disabled = !nowEnough;
      if (atcLabel) atcLabel.textContent = nowEnough ? baseLabel : `Pick ${target - done} more`;
      if (confettiOn && nowEnough && !wasEnough) burstConfetti();
      wasEnough = nowEnough;
    };

    const renderAll = () => {
      if (mode === 'fixed') renderSlotsFixed();
      else renderSlotsMinimum();
      renderCounts();
      renderProgress();
    };

    products.forEach((card) => {
      const addBtn = card.querySelector('[data-bundle-add]');
      if (!addBtn) return;
      addBtn.addEventListener('click', () => {
        if (mode === 'fixed' && picks.length >= size) return;
        picks.push({
          variantId: card.dataset.variantId,
          title: card.dataset.productTitle,
          image: card.dataset.productImage
        });
        renderAll();
      });
    });

    // Static remove buttons only exist in fixed mode; minimum-mode buttons are
    // wired as they are created.
    fixedSlots.forEach((slot, i) => {
      const remove = slot.querySelector('[data-bundle-slot-remove]');
      if (remove) remove.addEventListener('click', () => removeAt(i));
    });

    atc.addEventListener('click', () => {
      if (!enough()) return;
      atc.disabled = true;
      const original = atcLabel ? atcLabel.textContent : 'Adding';
      if (atcLabel) atcLabel.textContent = 'Adding…';
      const items = picks.map((p) => ({
        id: parseInt(p.variantId, 10),
        quantity: 1,
        properties: { [propertyName]: propertyValue || 'Bundle' }
      }));
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then((r) => {
          if (!r.ok) return r.json().then((j) => { throw new Error(j.description || 'Could not add bundle'); });
          return r.json();
        })
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          atc.disabled = false;
          if (atcLabel) atcLabel.textContent = original;
        })
        .catch((err) => {
          if (atcLabel) atcLabel.textContent = err.message || 'Could not add bundle';
          setTimeout(() => {
            if (atcLabel) atcLabel.textContent = original;
            renderProgress();
          }, 2400);
        });
    });

    renderAll();
  });
